export default __webpack_public_path__ + "static/media/LogoCastello.df8d9b1f.webp";